import { BaseController } from './BaseController';

export default class AnimationController extends BaseController {
  id = 'AnimationController';

  init() {
    this.root = this.getRoot();

    this.intersectionOptions = {
        rootMargin: '0px',
        threshold: 0.25,
    };

    document.addEventListener('readystatechange', this.startObserver);
  }

  startObserver = (event) => {
      if (event.target.readyState == "complete") {
          this.observer = new IntersectionObserver(this.handleIntersect, this.intersectionOptions);
          this.addTargets();
      }
  };

  handleIntersect = (entries, observer) => {
      entries.forEach(entry => {
          console.log(entry);
          if (entry.isIntersecting && !entry.target.classList.contains("mod-animate--on")) {
                entry.target.classList.add("mod-animate--on");
                observer.unobserve(entry.target);
          }
      });
  };

  addTargets = () => {
      let animationElements = document.querySelectorAll('.mod-animate');

      animationElements.forEach(ele => {
          this.observer.observe(ele);
      });
  };

}
